import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function BranchesPage() {
  return <InstituteCrudPage config={entityConfigs['branches']} />;
}
